module.exports = __webpack_public_path__ + "static/img/go-to-shopify.b6b9cd82.png";